import { TravelRequest } from '../..'

export const apiViajesPOST = async (travel: TravelRequest): Promise<Boolean> => {
  return true
}
